import { createClassName } from 'utils/createClassName';

import './searchInputLayoutStyles.scss';

export const createSearchInputLayoutClassName = createClassName(
  'searchInputLayout'
);
